import { useState, useEffect } from "react";
import Modal from "../../../../parts/modal-new";
import VideoUpload from "../components/VideoUpload";

const id = "modal-link-program";
const form = "link-program";

const LinkProgram = ({ workflow, explanationAdded }) => {
  const [addVideo, setAddVideo] = useState(false);
  useEffect(() => {
    if (explanationAdded) {
      setAddVideo(false);
    }
  }, [explanationAdded]);
  return (
    <form
      action={
        addVideo
          ? "/actions/getting-started/video"
          : "/actions/getting-started/link-program"
      }
      method="POST"
      encType="multipart/form-data"
      data-noreset
      id={form}
    >
      <input type="hidden" name="option" value="program" />
      <input type="hidden" name="workflow" value={workflow._id} />

      <Modal
        name={id}
        key={id}
        title="Link Questionnaire"
        className="getting-started-video narrow"
        toClear={["explanationAdded"]}
      >
        <div className="body">
          {addVideo ? (
            <VideoUpload
              form={form}
              video={workflow.options.program?.video}
              explanationVideo
              goBack={() => setAddVideo(false)}
            />
          ) : (
            <div className="form-row-item">
              <p className="p2 mb-4">
                Embed a quiz inside your app to help guide users through a
                series of custom questions to automatically recommend them the
                best program to use. This is a 3rd party service and must be
                purchased through MSB Services. Click{" "}
                <a
                  href="/coaching-portal/services?modal[type]=information&service=program-quiz"
                  target="_blank"
                >
                  HERE
                </a>{" "}
                to learn more.
              </p>
              <label className="sub-label" htmlFor="url">
                Enter URL
              </label>
              <input
                className="url-input"
                type="text"
                name="url"
                placeholder="Paste link for questionnaire"
                defaultValue={workflow.options.program?.url}
                form={form}
              />
            </div>
          )}
        </div>

        <footer className="foot">
          {!addVideo && !explanationAdded && (
            <button
              onClick={() => setAddVideo(true)}
              type="button"
              data-button-type="outline"
              className="mr-auto"
            >
              <span>Add Explanation Video</span>
            </button>
          )}
          <button data-button-type="primary" type="submit">
            {addVideo ? "Add Video" : "Save"}
          </button>
        </footer>
      </Modal>
    </form>
  );
};

export default LinkProgram;
